<template>
  <div class="tabbar" :class="{ noCommune: noCommuneOnSplash }">
    <router-link
      :is="noCommuneOnSplash ? 'span' : 'router-link'"
      :to="{ name: $namedRoutes.transactionOverview }"
      class="tabbar-entry"
    >
      <font-awesome-icon icon="address-card" class="tabbar-icon" />
      <NewTranslation class="tabbar-name" path="tabBar.item.tickets" />
    </router-link>
    <router-link
      :is="noCommuneOnSplash ? 'span' : 'router-link'"
      :to="{ name: $namedRoutes.benefitsOverview }"
      class="tabbar-entry"
    >
      <font-awesome-icon icon="coffee" class="tabbar-icon" />
      <NewTranslation class="tabbar-name" path="tabBar.item.benefits" />
    </router-link>
    <router-link
      :is="noCommuneOnSplash ? 'span' : 'router-link'"
      :to="{ name: loggedInUser ? $namedRoutes.profileOverview : $namedRoutes.login }"
      class="tabbar-entry"
    >
      <font-awesome-icon icon="user" class="tabbar-icon" />
      <NewTranslation class="tabbar-name" path="tabBar.item.profile" />
    </router-link>
    <router-link
      :is="noCommuneOnSplash ? 'span' : 'router-link'"
      :to="{ name: $namedRoutes.moreOverview }"
      class="tabbar-entry"
    >
      <font-awesome-icon icon="ellipsis-h" class="tabbar-icon" />
      <NewTranslation class="tabbar-name" path="tabBar.item.more" />
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NewTranslation from '@/components/i18n/NewTranslation';

export default {
  components: {
    NewTranslation,
  },
  props: {
    noCommuneOnSplash: {
      type: Boolean,
      default: false,
    },
  },
  computed: mapGetters(['loggedInUser']),
};
</script>

<style lang="sass" scoped>
.tabbar
	max-width: 480px
	z-index: 101
	width: 100%
	height: 80px
	display: flex
	box-shadow: 0 0 10px rgba(0, 0, 0, .3)
	position: fixed
	bottom: 0
	background-color: #fff
	&-entry
		color: #1DB2D1
		flex-grow: 1
		flex-basis: 100%
		display: flex
		justify-content: center
		align-items: center
		flex-direction: column
		&.router-link-active
			color: #ffffff
			background: #1DB2D1
	&-icon
		width: 25px
		height: 25px
		object-fit: contain
		object-position: center center
		margin-bottom: 2px
.tabbar.noCommune
		span
			&.tabbar-entry
				color: rgba(59, 59, 59, 0.3)
				background-color: #fff
				cursor: not-allowed
				span
					background-color: #fff
</style>
